























































import Vue from 'vue';
import { Dayjs } from 'dayjs';
const HOURS = [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21];

const WEEKDAYS = {
  lt: ['Sek', 'Pir', 'Ant', 'Tre', 'Ket', 'Pen', 'Šeš'],
  en: [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
  ],
  pl: ['Niedz', 'Pon', 'Wt', 'Śr', 'Czw', 'Pt', 'Sob'],
};

declare module 'vue/types/vue' {
  // 3. Declare augmentation for Vue
  interface Vue {
    $dayjs: any;
  }
}

export default Vue.extend({
  props: {
    props: {
      type: Object,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hours: HOURS,
      weekdays: WEEKDAYS,
      days: [] as any,
      currency: '€',
    };
  },
  created() {
    if (this.props.country === 'PL') {
      this.currency = 'zł';
    }
  },
  methods: {
    getDays() {
      const days = [];
      for (let i = 0; i < 60; i++) {
        const date = this.$dayjs().add(i, 'day');
        const timezone = {
          LT: 'Europe/Vilnius',
          PL: 'Europe/Warsaw',
        }[this.props.country as string];
        days.push({
          date,
          weekday: date.day(),
          monthday: date.date(),
          id: Math.random() + '',
          slots: HOURS.map((hour) => {
            const timeDate = this.$dayjs()
              .tz(timezone)
              .hour(hour)
              .startOf('hour')
              .add(i, 'day');
            return {
              available: this.isSlotAvailable(timeDate),
              id: Math.random() + '',
              textValue: timeDate.format('YYYY-MM-DD HH:mm'),
              timestamp: timeDate.toDate().getTime(),
            };
          }),
        });
      }
      return days;
    },
    getAvailabilitySlots() {
      return this.props.availabilitySlots;
    },
    isSlotAvailable(time: Dayjs) {
      for (let i = 0; i < this.getAvailabilitySlots().length; i++) {
        if ((this.getAvailabilitySlots()[i] as any).startTime === +time) {
          return this.getAvailabilitySlots()[i];
        }
      }
      return false;
    },
    renderHour(h: number) {
      if (h < 10) {
        return '0' + h + ':00';
      } else {
        return h + ':00';
      }
    },
    chooseTime(day: any) {
      const eventData = {
        focusNext: true,
        key: 'datetime',
        value: {
          textValue: day.textValue,
          timestamp: day.timestamp,
          expressCost: day.available.expressCost,
          distanceCost: day.available.prosAvailable[0].distanceCost,
          prosAvailable: day.available.prosAvailable,
        },
      };
      // console.log(eventData);
      this.$emit('save', eventData);
    },
  },
});
